import type { ModalProps } from '@mantine/core'

export const APP_MODAL_SIZE = 'min(92vw, 44rem)'

export const APP_MODAL_TRANSITION_PROPS: NonNullable<ModalProps['transitionProps']> = {
    transition: 'pop',
    duration: 320,
    timingFunction: 'cubic-bezier(0.22, 1, 0.36, 1)'
}

export const APP_MODAL_OVERLAY_PROPS: NonNullable<ModalProps['overlayProps']> = {
    backgroundOpacity: 0.52,
    blur: 6
}
